export default "__VITE_ASSET__nDSrlVLg__"